import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import ExternalLink from 'components/Widgets/ExternalLink';
import IconWithText from 'components/Widgets/IconWithText';

import Archive from './Archive';

export default function Index() {
  const [talentAssessments, setTalentAssessments] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.career_pulse_assessment_reports.index)
      .then((response) => {
        setTalentAssessments(response.data.data);
      });
  }, []);

  return (
    <section>
      <h4 className="mb-4">Talent Assessment</h4>

      <Row>
        <Col sm={9} lg={10}>
          <IconWithText
            iconClassName="certified-icon big-icon bg-secondary"
            contentClassName="mb-3 mb-sm-0"
            wrapperClassName="align-items-start"
          >
            <>
              <p>
                The Talent Assessment helps you identify your current strengths and potential areas for growth.
                {' '}
                Together with your coach, these insights can help shape your coaching engagement so that you focus
                {' '}
                on your specific needs for growth and development across the dimensions of Productivity and Wellbeing.
              </p>

              {talentAssessments === null ? (
                <LoadingPlaceholder />
              ) : (
                <Archive talentAssessments={talentAssessments} />
              )}
            </>
          </IconWithText>
        </Col>

        <Col sm={3} lg={2}>
          <a
            href={routes.members.talentAssessment.show}
            className={`
              btn btn-primary d-sm-block px-3 px-sm-0 mb-3 me-3 me-sm-0
              ${talentAssessments?.length > 0 ? '' : 'disabled'}
            `}
          >
            View
          </a>

          <a
            href={routes.members.talentAssessment.new}
            className={`
              btn btn-outline-primary btn-reverse d-sm-block px-3 px-sm-0 mb-3 me-3 me-sm-0
              ${talentAssessments === null ? 'disabled' : ''}
            `}
          >
            {talentAssessments?.length > 0 ? 'Update' : 'Start'}
          </a>

          <ExternalLink
            href={(talentAssessments?.length > 0 && talentAssessments[0].attributes.url) || ''}
            variant="outline-primary"
            className={`
              btn-reverse d-sm-block px-3 px-sm-0 mb-3 mb-sm-0 ${talentAssessments?.length > 0 ? '' : 'disabled'}
            `}
          >
            Report
          </ExternalLink>
        </Col>
      </Row>
    </section>
  );
}
